module.exports = __webpack_public_path__ + "img/srf-logo-3.5df78e0.svg";